<template>
  <el-table-column
    prop="ntax_partner.supplier_ntax_code"
    label="NTAX kód"
    width="150"
    sortable="custom"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span
        v-if="scope.row.ntax_partner"
      >
        {{ scope.row.ntax_partner.supplier_ntax_code }}
      </span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ntax_partner.supplier_ntax_code',
  };
</script>
